
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/roi-calculator",
      function () {
        return require("private-next-pages/resources/roi-calculator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/roi-calculator"])
      });
    }
  